<template>
  <section :style="cssVars" class="body--detail--message-section" :class="isTheModal ? 'message-section--modal' : ''">
    <b-container v-if="message.type === 'message'">
      <b-row :class="isRight? 'body--message-row-right' : 'body--message-row'">
        <b-col v-if="!isRight" class="body--col-left">
          <b-img v-if="message.logo.logoUrl || message.logo.logoUrl2 || message.logo.logoVerify" v-bind="mainProps" rounded="circle" :alt="message.logo.name" @error="failImg"></b-img>
          <feather-icon v-else class="drop--down-photo" icon="UserIcon"/>
        </b-col>
        <b-col class="body--col-middle">
          <b-card no-body class="body--detail--message">
            <div class="body--detail--card-body">
              <div class="body--detail--card-head">
                <strong v-show="!!message.user_name">{{message.user_name}}</strong>
                <b-badge class="body--detail--badge" v-show="message.hidden" variant="danger" title="Mensaje oculto">Mensaje oculto</b-badge>
                <b-badge class="body--detail--badge" v-show="message.title" :variant="message.title_color === 'plain' ? 'light-secondary' : 'light-warning'" title="Nuevo asunto">Nuevo asunto: {{message.title}}</b-badge>
                <b-badge class="body--detail--badge" v-show="message.new_type_name" :variant="message.new_type_color === 'plain' ? 'light-secondary' : 'light-warning'" title="Nuevo asunto"> {{message.new_type_name}}</b-badge>
              </div>
              <p class="m-0 body--detail--message-text mt-1 mb-1">{{message.message}}</p>
              <div class="body--footer--container">
                <div class="first">
                  <p v-if="message.resolution_date_label" class="text--resolution m-0 p-0">{{ message.resolution_date_label }}
                    <b-icon v-if="message.resolution_date && message.resolution_date_log && message.resolution_date_log.resolutionDays" :id="isTheModal ? `tooltip-target-modal-${message.index}` : `tooltip-target-${message.index}`" icon="info-circle" variant="light"></b-icon>
                  </p>
                  <b-tooltip v-if="message.resolution_date && message.resolution_date_log && message.resolution_date_log.resolutionDays" :target="isTheModal ? `tooltip-target-modal-${message.index}` : `tooltip-target-${message.index}`" triggers="hover">
                    <b>Num. días de resolución:</b> {{message.resolution_date_log.resolutionDays}}<br>
                    <b>Descripción de problema:</b> {{message.resolution_date_log.note}}<br>
                    <b>Campo inicio de conteo:</b> {{message.resolution_date_log.initDateField}}<br>
                    <b>Fecha de inicio de conteo:</b> {{message.resolution_date_log.initDateValue}}
                  </b-tooltip>
                </div>
                <div class="second">
                  <b-badge v-b-tooltip.hover :title="dataMessage.titleStatusCode" variant="warning" v-if="dataMessage.textStatusCode" class="badge--text-status-code">{{dataMessage.textStatusCode}}</b-badge>
                  <b-button @click="openModalDelete(message)" v-if="message.deletable" variant="link" class="p-0 text-danger">{{message.deletable.label}}</b-button>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col v-if="isRight" class="body--col-right">
          <div class="drop--down-photo--container">
            <icons  class="drop--down-photo" :icon="'EnviameCube'" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="p-0" :class="isRight? 'text-right' : ''">
          <span class="body--detail--create-at">{{message.created_at_formatted}}</span>
        </b-col>
      </b-row>
    </b-container>
    <div v-if="message.type === 'tag'"  class="body--tag-container">
      <div class="body--tag-message">
        <p class="body--tag-message-text">{{message.tracking_data.name}}</p>
        <b-icon :id="isTheModal ? `tooltip-target-tag-modal-${index}` : `tooltip-target-tag-${index}`" icon="info-circle" variant="light"></b-icon>
        <b-tooltip :target="isTheModal ? `tooltip-target-tag-modal-${index}` : `tooltip-target-tag-${index}`" triggers="hover" placement="bottom">
          <b>CÓDIGO: {{message.tracking_data.code ? message.tracking_data.code : '--'}}</b>
          <br><br>
          <b>ESTADO COURIER:</b> {{message.tracking_data.carrier_status ? message.tracking_data.carrier_status : '--'}} <br>
          <b>ORIGEN:</b> {{message.tracking_data.carrier_origin ? message.tracking_data.carrier_origin : '--'}} <br>
          <b>FECHA ESTADO: {{message.tracking_data.carrier_status_date ? message.tracking_data.carrier_status_date : '--'}} </b> <br>
          <br>
          <b>ESTADO ENVÍAME: {{message.tracking_data.enviame_status ? message.tracking_data.enviame_status : '--'}}</b> <br>
          <b>COMENTARIO:{{message.tracking_data.enviame_comment ? message.tracking_data.enviame_comment : '--'}} </b> <br>
          <b>ORIGEN:{{message.tracking_data.enviame_origin ? message.tracking_data.enviame_origin : '--'}} </b> <br>
          <b>FECHA TRACKING: {{message.tracking_data.enviame_status_date ? message.tracking_data.enviame_status_date : '--'}} </b> 
        </b-tooltip>
      </div>
      <span class="body--detail--create-at">{{message.created_at_formatted}}</span>
    </div>
  </section>
</template>
<script>
import {
  BBadge,
  BIcon,
  BIconInfoCircle,
  BContainer,
  BRow,
  BCol
} from 'bootstrap-vue'
/* eslint-disable vue/no-unused-components */
import BaseServices from '@/store/services/index'
import Icons from '@/Icons/Icons.vue'
export default {
  props: ['message', 'ticket_id', 'index', 'isTheModal', 'masterData'],
  components: {BBadge, BIcon, BIconInfoCircle, BContainer, BRow, BCol, Icons},
  computed: {
    isRight() {
      return this.message.align === 'right'
    },
    cssVars() {
      return {
        '--size-icon' : this.isTheModal ? '5.5rem' : '3.5rem',
        '--size-logo' : this.isTheModal ? '4.5rem' : '2.5rem'
      }
    },
    dataMessage() {
      const dataStatus = this.masterData?.statusFormatted?.length > 0 ? this.masterData.statusFormatted.find(el => el.code === this.message.status_code) : {}
      return {
        textStatusCode: dataStatus?.complete_name ?? this.message.status_code,
        titleStatusCode: dataStatus?.text ?? this.message.status_code
      }
    }
  },
  data() {
    return {
      baseService: new BaseServices(this),
      mainProps: {
        class: 'image drop--down-photo enlarge-on-hover',
        src: this.message.logo.logoUrl
      },
      tryImage: 'logoUrl'
    }
  },
  methods: {
    openModalDelete(message) {
      const options = {
        title: '',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: message.deletable.label,
        cancelTitle: 'Cancelar',
        cancelVariant: 'danger',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-0 border-top-0',
        centered: true
      }
      this.$bvModal.msgBoxConfirm(message.deletable.confirmation_message, options)
        .then(value => {
          if (value) {
            this.removeMessage(message)
          }
        })
    },
    removeMessage(message) {
      const queryParams = {
        index: message.index
      }
      const params = {
        ticket_id: this.ticket_id
      }
      this.baseService.callService('deleteRemoveMessage', queryParams, params)
        .then(resp => {
          this.$success('Acción realizada correctamente')
        })
        .catch(err => {
          console.error(err)
          const text = 'Ocurrió un problema al realizar la acción'
          let textMessage = ''
          if (Array.isArray(err)) {
            textMessage += '<ul style="list-style-type: disc;">'
            err.forEach(element => {
              textMessage += `<li>${element.message}</li>`
            })
            textMessage += '</ul>'
          } else {
            textMessage = err
          }
          this.$alert(textMessage ? textMessage : text)
        })
        .finally(() => {
          this.$emit('updateTicket', true)
        })
    },
    failImg() {
      if (this.tryImage === 'logoUrl') {
        this.mainProps.src = this.message.logo.logoUrl2
        this.tryImage = 'logoUrl2'
      } else if (this.tryImage === 'logoUrl2') {
        this.mainProps.src = this.message.logo.logoVerify
        this.tryImage = 'logoVerify'
      } else {
        this.mainProps.src = ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .body--detail--message {
    background: transparent;
    width: 100%;
    // border-radius: 60px 60px 60px 0;
    margin: 0;

    .body--detail--card-body {
      padding: 20px;
      display: grid;
    }

    .body--detail--card-head {
      display: flex;
      gap: 10px;
    }

    &-text {
      white-space: preserve;
      font-size: 12px;
      overflow: auto;
    }
  }

  .drop--down-photo {
    width: var(--size-logo);
    height: calc(var(--size-logo) * 1.17);
    background-color: transparent;
    // padding: .5rem;
  }
  .drop--down-photo--container {
    background-color: #E8EDF1;
    border-radius: 50%;
    width: calc(var(--size-icon) + .2rem);
    height: calc(var(--size-icon) + .2rem);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .image.drop--down-photo {
    width: var(--size-icon);
    height: var(--size-icon);
    padding: 0;
    object-fit: contain;
    border-radius: var(--size-icon);
  }
  .body--message-container {
    display: grid;
    grid-template-columns: var(--size-icon) 1fr;
    gap: 5px;
    align-items: end;
  }
  .body--detail--create-at {
    font-size: 10px;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: 0.21633554995059967px;
    padding: 5px 0 0 0;
    text-align: left;
    grid-column: 2 / 2;
  }
  .body--detail--message-right {
    grid-template-columns: 1fr var(--size-icon);
    justify-items: flex-end;
    align-items: end;
  }

  .body--footer--container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    justify-items: stretch;

    button {
      width: fit-content;
    }
    .first, .second {
      display: grid;
      .badge {
        white-space: normal;
        text-align: right;
      }
    }
    .first {
      justify-items: self-start;
    }
    .second {
      justify-items: flex-end
    }
  }
  .body--detail--message-right {
    .body--detail--message {
      float: right;
      // background: #DDEFFF;
      // border-radius: 60px 60px 0px 60px;
    }
    .body--detail--create-at {
      grid-column: 1 / 2;
    }
  }
  .body--detail--badge {
    width: min-content;
    align-self: center;
  }
  .body--tag-container {
    display: flex;
    flex-flow: column;
    align-items: center;

    .body--tag-message {
      width: 100%;
      height: 75px;
      gap: 0;
      // border-radius: 60px 0 60px 0;
      background: #FDF3D0;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 5px;

      &-text {
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 700;
        line-height: 15px;
        text-align: center;
        margin: 0;
        color: #6E6B7B;
      }
    }
  }
  .text--resolution {
    font-family: Montserrat;
    font-size: 10px;
    font-weight: 500;
    line-height: 15px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #5C5C5C;
  }
  .body--col-left,
  .body--col-right  {
    flex: 0 0 10%;
    max-width: 10%;
    padding: 0;
    align-content: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .body--col-middle {
    flex: 0 0 90%;
    max-width: 90%;
    padding: 0;
  }

  .body--message-row {
    background: #E6E6E6;
  }
  .body--message-row-right {
    background: #DDEFFF;
  }
  .body--detail-chat-container .badge--text-status-code  {
    opacity: 1;
  }
  .body--detail-chat-container .badge--text-status-code:last-child{
    opacity: .7;
  } 

  .second .badge-warning {
    font-family: Montserrat;
    font-weight: 400;
    font-size: 10px;
    line-height: 12.19px;
    letter-spacing: 0%;
    text-align: center;
    background: #E48E3F;
  }

  .enlarge-on-hover {
    transition: transform 0.3s ease;
  }
  .enlarge-on-hover:hover {
    transform: scale(2);
  }

.message-section--modal {
  .body--col-left,
  .body--col-right  {
    flex: 0 0 15%;
    max-width: 15%;
  }

  .body--col-middle {
    flex: 0 0 85%;
    max-width: 85%;
  }
}
</style>